__turbopack_context__.v({
  "arrow": "CardList-module__BVaFZq__arrow",
  "badge": "CardList-module__BVaFZq__badge",
  "badgePrimary": "CardList-module__BVaFZq__badgePrimary",
  "badgeSuccess": "CardList-module__BVaFZq__badgeSuccess",
  "badgeWarning": "CardList-module__BVaFZq__badgeWarning",
  "card": "CardList-module__BVaFZq__card",
  "cardBody": "CardList-module__BVaFZq__cardBody",
  "cardHeader": "CardList-module__BVaFZq__cardHeader",
  "cardLabel": "CardList-module__BVaFZq__cardLabel",
  "cardList": "CardList-module__BVaFZq__cardList",
  "cardListVertical": "CardList-module__BVaFZq__cardListVertical",
  "cardRow": "CardList-module__BVaFZq__cardRow",
  "cardTime": "CardList-module__BVaFZq__cardTime",
  "cardTitle": "CardList-module__BVaFZq__cardTitle",
  "cardValue": "CardList-module__BVaFZq__cardValue",
  "container": "CardList-module__BVaFZq__container",
  "containerNoBg": "CardList-module__BVaFZq__containerNoBg",
  "copyButton": "CardList-module__BVaFZq__copyButton",
  "empty": "CardList-module__BVaFZq__empty",
  "fadeIn": "CardList-module__BVaFZq__fadeIn",
  "hash": "CardList-module__BVaFZq__hash",
  "header": "CardList-module__BVaFZq__header",
  "shimmer": "CardList-module__BVaFZq__shimmer",
  "skeleton": "CardList-module__BVaFZq__skeleton",
  "sourceLink": "CardList-module__BVaFZq__sourceLink",
  "title": "CardList-module__BVaFZq__title",
  "txIcon": "CardList-module__BVaFZq__txIcon",
  "viewAll": "CardList-module__BVaFZq__viewAll",
});
